import { DollarCircleIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const CircleDollarSign = /* @__PURE__ */ createIcon(DollarCircleIcon, 'CircleDollarSign');
